import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  template: '<router-outlet></router-outlet>',
})
export class AuthLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
